var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-box"},[_c('span',{staticClass:"time"},[_vm._v(" 剩余时间: "),_c('van-count-down',{ref:"aaa",attrs:{"time":_vm.time},on:{"change":_vm.timeChange}})],1),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta || !_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }